import { motion } from "framer-motion";
import { Navigation, Clock, CreditCard, MapPin, Users, Gift, Headphones } from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";
import SectionHeading from "../../components/premium/layout/SectionHeading";
import MagneticButton from "../../components/premium/hero/MagneticButton";
import rudraImg from "../../assets/images/rudra-ride-logo.png";

const features = [
  { icon: Navigation, title: "Instant Booking", desc: "Book rides in seconds with a seamless app experience." },
  { icon: MapPin, title: "Live Tracking", desc: "Real-time GPS from pickup to drop-off." },
  { icon: CreditCard, title: "Secure Wallet", desc: "UPI, cards, and in-app wallet payments." },
  { icon: Clock, title: "24/7 Service", desc: "Rides available anytime, anywhere." },
  { icon: Gift, title: "Referral Rewards", desc: "Earn rewards when you refer friends." },
  { icon: Headphones, title: "24/7 Support", desc: "Dedicated customer care for every ride." },
];

export default function RudraRidePage() {
  return (
    <PageShell>
      <PageHero
        badge="Smart Mobility"
        title="Rudra"
        highlight="Ride"
        subtitle="Your premium cab service — reliable, secure, and built for modern commuting."
      >
        <div className="flex justify-center mt-8">
          <div className="px-6 py-5 rounded-2xl bg-white shadow-xl">
            <img src={rudraImg} alt="Rudra Ride" className="max-h-36 object-contain" />
          </div>
        </div>
      </PageHero>

      <section className="py-16 premium-section-alt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading badge="Features" title="Built for Riders & Drivers" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="premium-glass rounded-2xl p-6 hover:border-[#2563EB]/40 transition-colors"
              >
                <div className="w-12 h-12 rounded-xl bg-[#2563EB]/30 flex items-center justify-center text-[#60a5fa] mb-4">
                  <f.icon size={22} />
                </div>
                <h3 className="font-bold text-white">{f.title}</h3>
                <p className="mt-2 text-sm text-white/55">{f.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="premium-glass rounded-3xl p-8 lg:p-10">
            <Users className="text-[#F5C044] mb-4" size={32} />
            <h3 className="text-2xl font-bold text-white">For Drivers & Partners</h3>
            <p className="mt-4 text-white/65 leading-relaxed">
              Join our growing network. Fair earnings, flexible schedules, and technology that puts drivers first.
            </p>
          </div>
          <div className="premium-glass rounded-3xl p-8 lg:p-10 h-64 flex items-center justify-center border border-dashed border-white/20">
            <p className="text-white/40 text-center">App screenshots & map preview<br /><span className="text-sm">Coming at launch</span></p>
          </div>
        </div>
      </section>

      <section className="py-16 text-center">
        <MagneticButton to="/launch-event" variant="glass">Launch Recap</MagneticButton>
      </section>
    </PageShell>
  );
}
